import React, { useState } from 'react'
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Tag, Space } from 'antd';
import { Switch } from 'antd';
import { DatePicker, TimePicker } from 'antd'
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

const StoresList = [
    {
        Label: "Connect Store - ITPB",
        Value: 1
    },
    {
        Label: "Connect Store- Indiranagar",
        Value: 2
    },
    {
        Label: "Sarjapur",
        Value: 3
    },
    {
        Label: "Anubhava (New Airport Road)",
        Value: 4
    },
    {
        Label: "EVA Mall - Brigade",
        Value: 5
    },
    {
        Label: "R-city(Mumbai)",
        Value: 6
    },
    {
        Label: "Amanora Mall",
        Value: 7
    },
    {
        Label: "OMR Padur(Chennai)",
        Value: 8
    },
    {
        Label: "Teynampet / Ramee Mall / Anna Salai",
        Value: 9
    },
    {
        Label: "Kukatpally (Manjeera Mall)",
        Value: 10
    },
    {
        Label: "Vishakapatnam (Murli Nagar)",
        Value: 11
    },
]

const PaymentProcessSOM = () => {
    const title = "Payment Process by SOM";
    const navigate = useNavigate();
    const [storesList, setStoresList] = useState(StoresList)
    const [IsPaymentUpdateOpen, setIsPaymentUpdateOpen] = useState(false);
    const [isAccpeted, setIsAccepted] = useState(false);
    const _doNavToPaymentUpdate = () => {
        setIsPaymentUpdateOpen(true);
        setIsAccepted(false);
    }
    const _doCloseModal = () => {
        setIsPaymentUpdateOpen(false);
        setIsAccepted(false);
    }
    const _doNavToPaymentListSOM = () => {
        navigate('./PaymentInvoiceProcessSOM');
    }

    const _doSelectVender = () => {

    }
    
    const TableData = [
        {
            key: '1',
            BudgetCategory: "Preventive Maintainance",
            AssetCategory: "Electrical ",
            TotalAmount: 10100
        },
        {
            key: '2',
            BudgetCategory: "Corrective Maintainance",
            AssetCategory: "Electrical ",
            TotalAmount: 10100
        }

    ]
    const TableColumns = [
        {
            title: "Budget Category",
            dataIndex: "BudgetCategory",
            key: "BudgetCategory"
        },
        {
            title: "Asset Category",
            dataIndex: "AssetCategory",
            key: "AssetCategory"
        },
        {
            title: "Total Amount",
            dataIndex: "TotalAmount",
            key: "TotalAmount"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <span className="fa fa-trash-o text-danger"></span>
                    </div>
                </Space>
            ),
        }

    ]

    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            <div className='content-wrapper'>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                            <div className="m-paymentdetails">
                                    <div className="paymentheader">
                                        <span className="vendorPayment_header">Vendor Payment Details</span>
                                        <span>Status : <label className="pending_status">Accepted</label></span>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Vendor Name* </label>
                                                <label className="content_label col-md-6">Name</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">GST Number* </label>
                                                <label className="content_label col-md-6">GTIN9204092333</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Decatholon GST Number* </label>
                                                <label className="content_label col-md-6">GTIN9204092333</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Decatholon Third Code* </label>
                                                <label className="content_label col-md-6">82342384392</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Contract Name* </label>
                                                <label className="content_label col-md-6">1060-Vendor-AMC</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Vendor GST Number* </label>
                                                <label className="content_label col-md-6">GTIN2942107489</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">HSN/SAC Number* </label>
                                                <label className="content_label col-md-6">HSN902148924</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Nature of Service*</label>
                                                <label className="content_label col-md-6">Simple</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Contract End Date* </label>
                                                <label className="content_label col-md-6">11-11-2021</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Invoice Number* </label>
                                                <label className="content_label col-md-6">12242</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Invoice Date* </label>
                                                <label className="content_label col-md-6">5-Jun-20</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Amount* </label>
                                                <label className="content_label col-md-6">20000</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">GST*(%) </label>
                                                <label className="content_label col-md-6">18%</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">GST Value* </label>
                                                <label className="content_label col-md-6">3600</label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <label className="col-md-6 item_label">Total Amount* </label>
                                                <label className="content_label col-md-6">23600</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-paymentdetails-form">
                                    <h4>Verify Payment Details</h4>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInput">Budget Category*</label>
                                                <input type="text" className="form-control" disabled />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInput">Asset Main Category</label>
                                                <Select className="form-control" disabled>
                                                   <Option>Select</Option>
                                                </Select>
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='exampleInput'>Amount(Excluding GST)*</label>
                                                <input type="text" className="form-control" disabled />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='exampleInput'>Finance Approval*</label>
                                                <div className="">
                                                    <Switch checkedChildren="Yes" unCheckedChildren="No" defaultChecked></Switch>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor='exampleInput'>Remarks by Finance Team</label>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="m-table__main">
                                        <div className="m-table__responsive medium-width">
                                            <Table columns={TableColumns} dataSource={TableData}
                                                summary={pageData => {
                                                    let Total = 0;
                                                    pageData.forEach(({ TotalAmount }) => {
                                                        Total += TotalAmount;
                                                    });
                                                    return (
                                                        <>
                                                            <Table.Summary.Row>
                                                                <Table.Summary.Cell colSpan={2}>Total</Table.Summary.Cell>
                                                                <Table.Summary.Cell colSpan={2}>{Total}</Table.Summary.Cell>
                                                            </Table.Summary.Row>
                                                        </>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-right p10">
                                    <button type="submit" onClick={_doNavToPaymentUpdate} className="btn btn-secondary deca-btn-yellow">Update Payment Details</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />

            {
                IsPaymentUpdateOpen === true ?
                    <div className="m-modal">
                        <div className="m-modal__container">
                            <div className="m-modal__header">
                                <h5 className="m-modal__title">Update Payment Details</h5>
                                <span className="m-modal__close" onClick={_doCloseModal}>
                                    <i className="fa fa-close"></i>
                                </span>
                            </div>
                            <div className="m-modal__body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Payment Date*</label>
                                            <DatePicker className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Document Number*</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Payee Number*</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Document Number*</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Alpha Name*</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center">
                                        <div className="m-page__button top-space text-center">
                                           <button type='button' onClick={_doCloseModal} className='btn btn-secondary deca-btn-yellow color-red'>Cancel</button>
                                           <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : false
            }
            {
                IsPaymentUpdateOpen === true ?
                    <div className="overlay" onClick={_doCloseModal}>

                    </div>
                    : false
            }
        </div>
    )
}

export default PaymentProcessSOM